import Editor from "react-simple-code-editor";
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-markup';

export default function CodeEditor({ value, onChange, syntax }) {
    return <Editor
        value={value}
        onValueChange={code => onChange(code)}
        highlight={code => highlight(code, languages[syntax])}
        padding={10}
        preClassName="language-"
        style={{
            minHeight: '300px',
            fontFamily: '"Fira code", "Fira Mono", monospace',
            fontSize: 12,
            border: '1px solid #ced4da',
            borderRadius: '.25rem'
        }}
    />;
}
